export type PackageType = 'CSV' | 'MP4' | 'AUTO_CSV';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isPackageType = (data: any): data is PackageType => data === 'CSV' || data === 'MP4' || data === 'AUTO_CSV';
